// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'firaSans', 'firaSans Fallback'"},"className":"__className_87a8de","variable":"__variable_87a8de"};